import React, { Component } from 'react'
import { Select } from 'hljd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
const Option = Select.Option

@observer
class SearchInput extends Component {
  onNameChange = value => {
    const { onChange } = this.props
    onChange && onChange(value)
  }
  onSearch = value => {
    const { onSearch, onChange } = this.props
    onSearch && onSearch(value)
    onChange && onChange(value)
  }
  render() {
    const { store, value } = this.props
    const searchResult = toJS(store.searchResult) || []
    return (
      <Select
        showSearch
        value={value}
        placeholder="请输入名称"
        showArrow={false}
        filterOption={false}
        onSearch={this.onSearch}
        onChange={this.onNameChange}
        notFoundContent={null}
        style={{ width: 272 }}
      >
        {searchResult.map(d => <Option key={d.id}>{d.title}</Option>)}
      </Select>
    )
  }
}

export default SearchInput
